const a = {
  default: 64,
  expressive: 64,
  small: 54
}, e = {
  default: 44,
  expressive: 44,
  small: 54
}, r = {
  dueNow: "dueNow",
  otherPayments: "otherPayments",
  primary: "primary",
  secondary: "secondary"
}, s = {
  affirm: "affirm",
  amex: "amex",
  applePay: "applePay",
  card: "card",
  diners: "diners",
  discover: "discover",
  googlePay: "googlePay",
  jcb: "jcb",
  mastercard: "mastercard",
  newCard: "newCard",
  paypal: "paypal",
  visa: "visa"
}, d = ["amex", "diners", "discover", "jcb", "mastercard", "newCard", "visa"], n = ["diners", "discover", "jcb"], t = ["affirm", "amex", "masterCard", "paypal", "visa"], c = ["newCard", "card"];
export {
  s as Brands,
  d as BrandsWithCardNumber,
  a as OtherPaymentMethodsSizes,
  c as OtherPaymentsOnly,
  t as PrimaryOnlyBrands,
  n as SecondaryOnlyBrands,
  e as Sizes,
  r as Variants
};
